import { IJsonQuery } from '../json_query';

export function saveJsonQueryInLocalStorage(jsonQuery: IJsonQuery) {
  /* istanbul ignore next */
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage.setItem('__serp_jsonQuery__', JSON.stringify(jsonQuery));
    //oxlint-disable-next-line no-empty
  } /* istanbul ignore next */ catch (e) {}
}
